// extracted by mini-css-extract-plugin
export default {"row":"Addresses_row__sphwh","inputs":"Addresses_inputs__AvOPz"};